import { useMutation } from '@apollo/client/react';
import { loggerService } from '@brainpool/logger';
import { LoggerContextProps } from '../types/LogContext';
import { UseHookOptions } from '../types/UseHookOptions';
import { UPDATE_USER } from '../queries/UpdateUser';
import { User } from '../types/User';
import { GET_USER } from '../queries/GetUser';
import { handleError } from './errorHandler';

type UpdateUserInput = Pick<User, 'user_preferences'>;

const context: LoggerContextProps = {
  action: 'updateUser',
};
export function useUpdateUser(options: UseHookOptions = {}) {
  const [updateUserQuery, { data, loading, error }] = useMutation<{
    updateUser: {
      success: boolean;
    };
  }>(UPDATE_USER, {
    refetchQueries: [{ query: GET_USER }],
  });

  const updateUser = async (input: UpdateUserInput) => {
    try {
      const { data } = await updateUserQuery({
        variables: { input },
      });
      if (data?.updateUser.success) {
        loggerService.log({
          message: `User updated successfully.`,
          logLevel: 'success',
          context,
        });
      }
    } catch (error) {
      handleError(error, context, 'Failed to update user.');
    }
  };

  return { updateUser, data, loading, error };
}
